import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

export type Option<T = string> = {
    label: string;
    value: T;
    isDisabled?: boolean;
};

export type SelectedOption<T = string> = Option<T> | null | undefined;

type TotemCheckboxProps = {
    disabled?: boolean;
    label?: string;
    checked: boolean;
    onChange: () => void;
};

export function TotemCheckbox({ label, checked, onChange, disabled }: TotemCheckboxProps) {
    return (
        <div className="relative inline-flex items-center gap-1.5">
            <Checkbox
                checked={checked}
                onCheckedChange={onChange}
                disabled={disabled}
                className="size-[22px] rounded-md [&_[data-slot=checkbox-indicator]_svg]:size-5"
            />
            {label ? (
                <Label
                    className={`text-lg font-normal ${disabled ? 'text-muted-foreground' : 'text-foreground'}`}
                    onClick={onChange}
                >
                    {label}
                </Label>
            ) : null}
        </div>
    );
}
